// ─── LIVRAISON — source unique des CHIFFRES et des NOMS affichés au public ───
//
// Pourquoi ce module existe (mesuré le 20/08/2026) : la même phrase circulait
// sur cinq pages publiques avec TROIS vérités différentes —
//   · StaticPages.js (FAQ + JSON-LD) et LongTailLandings.js : « à partir de 5,10 € »
//   · CategoryPage.js                                        : « à partir de 4,10 € »
//   · le prix RÉELLEMENT facturé par le rail Boxtal actif     :          3,59 €
// Les deux chiffres publiés étaient donc faux, et tous deux SURESTIMAIENT le
// prix : Gively se desservait tout en affichant une information inexacte à des
// consommateurs. Ces pages sont aussi celles que Google indexe (FAQPage), donc
// l'incohérence était publique et durable.
//
// Règle CLAUDE.md : « aucun nom de transporteur, aucun montant, aucun taux
// écrit en dur sur un écran qui dépend d'un choix ».
//
// SOURCE DE VÉRITÉ : backend/services/delivery_pricing.py — grille Boxtal HT
// `_BOXTAL_FR_RELAY_HT` + TVA 20 % + marge Boxtal (0,00 €, refacturation à
// l'identique). Le plancher ci-dessous est le TTC le moins cher tous réseaux
// confondus pour le palier le plus léger (250 g) : Chronopost 2,99 HT → 3,59 TTC.
//
// GARDE-FOU : backend/tests/test_prix_livraison_public.py RECALCULE ce plancher
// depuis la grille et échoue si la valeur publiée s'en écarte. Une grille qui
// bouge sans que la vitrine suive fait ROUGIR la CI — c'est la seule façon
// qu'un chiffre marketing reste vrai dans le temps.

import { fmtEur } from "../utils/statusTone";

/** Plancher TTC réellement facturé à l'acheteur, en euros. */
export const LIVRAISON_PRIX_PLANCHER_EUR = 3.59;

/** Le plancher, formaté à la française : « 3,59 € ».
 *  Passe par `fmtEur`, le formatteur partagé du LOT 3 — un montant formaté à la
 *  main est exactement ce qui produisait « 45.00 € » sur un écran et
 *  « 45,00 € » sur un autre pour la MÊME annonce. */
export const LIVRAISON_PRIX_PLANCHER = fmtEur(LIVRAISON_PRIX_PLANCHER_EUR);

/**
 * Réseaux de points relais réellement proposés, dans l'ordre de la grille.
 * Ce sont des RÉSEAUX derrière Boxtal, jamais des intégrations Gively —
 * l'écrire autrement laisse croire à un contrat direct qui n'existe pas.
 */
export const RESEAUX_RELAIS = ["Mondial Relay", "Chronopost", "Colis Privé", "UPS"];

/**
 * LE NOM DU PRESTATAIRE. Une constante, pas une chaîne recopiée.
 *
 * Règle d'or du 09/09/2026 : tout écran qui parle de livraison nomme BOXTAL.
 * Citer « Mondial Relay » nu — surtout à côté du logo Stripe, sous un titre
 * « Pourquoi nous faire confiance » — laisse déduire un contrat direct qui
 * n'existe pas, et le lecteur a raison de le déduire : le parallélisme EST le
 * message.
 */
export const PRESTATAIRE_LIVRAISON = "Boxtal";

/** « Boxtal — Mondial Relay, Chronopost, Colis Privé, UPS »
 *  Le prestataire d'abord, les réseaux ensuite : c'est la hiérarchie réelle. */
export const LIVRAISON_PRESTATAIRE_ET_RESEAUX =
  `${PRESTATAIRE_LIVRAISON} — ${RESEAUX_RELAIS.join(", ")}`;

/** « Mondial Relay, Chronopost, Colis Privé ou UPS » */
export const RESEAUX_RELAIS_TEXTE = RESEAUX_RELAIS.slice(0, -1).join(", ")
  + " ou " + RESEAUX_RELAIS[RESEAUX_RELAIS.length - 1];

/** Phrase courte réutilisable en FAQ, JSON-LD et pages SEO.
 *
 *  ⚠️ Le suivi ne concerne QUE le point relais. La phrase d'origine — reprise
 *  telle quelle du texte que ce module remplaçait — affirmait « le suivi est
 *  inclus dans tous les cas », ce qui est faux pour la remise en main propre :
 *  il n'y a pas de colis, donc pas de numéro de suivi. Cette phrase partait
 *  dans le JSON-LD (balisage FAQPage) de la page d'accueil, donc dans ce que
 *  Google restitue. Relevé en revue de #2182, après merge. */
export const LIVRAISON_RESUME =
  `Livraison en point relais à partir de ${LIVRAISON_PRIX_PLANCHER} `
  + `(${RESEAUX_RELAIS_TEXTE}, via notre prestataire logistique Boxtal), suivi inclus. `
  + `Ou remise en main propre, sans colis ni suivi, si le vendeur la propose.`;

export default LIVRAISON_RESUME;
